import { useEffect, useState } from "react";
import { S3, WIDGET_ICONS } from "../../../../../../constants";
import ImageRadio from "../../../../../../parts/inputs/image-radio";
import scriptLoader from "../../../../../../utils/scriptLoader";
import { isPullActiveCoach } from "../../../../../../utils/user-helpers";
import {
  deleteWidgetUtil,
  orderWidgets,
} from "../../../../../../utils/widgets";
import { EditRecipe } from "./EditRecipe";

import submit from "submit-form";
import { getUserToRequest } from "../../../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import ConfirmationModal from "../../../../../../parts/modals/ConfirmationModal";
import SvgIcon from "../../../../../../parts/SvgIcon";
import WidgetManagerHeader from "./WidgetManagerHeader";
import { EditWidgetInfoModal } from "../../../../../../parts/modals/EditWidgetInfo";
import useCompareState from "../../../../../../hooks/useCompareState";

/**
 * Publish a recipe
 * @param {*} id
 */
const publishWidget = (id) => {
  submit(`/actions/recipes/status/${id}`, {
    method: "POST",
    body: { status: "published" },
  });
};

/**
 * Unpublish a recipe
 * @param {*} id
 */
const unpublishWidget = (id) => {
  submit(`/actions/recipes/status/${id}`, {
    method: "POST",
    body: { status: "draft" },
  });
};

/**
 * Change the status of a recipe
 * @param {*} param0
 * @returns
 */

const WidgetToggle = ({ status, id }) => {
  const [value, setValue] = useState(status === "draft" ? false : true);
  const [openedConfirmationModal, setOpenedConfirmationModal] = useState(false);
  const isPublished = status === "published" ? true : false;

  const handleChange = () => {
    !value ? unpublishWidget(id) : publishWidget(id);
    setTimeout(() => {
      setOpenedConfirmationModal(false);
    }, 500);
  };
  return (
    <>
      <input
        type="checkbox"
        id={`switch-${id}`}
        name={`switch-${id}`}
        role="switch"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onChange={(e) => {
          setValue(!value);
          setOpenedConfirmationModal(!openedConfirmationModal);
        }}
        checked={isPublished}
      />
      <ConfirmationModal
        title={!value ? "Unpublish" : "Publish"}
        contentText={`Are you sure you want to ${
          !value ? "unpublish" : "publish"
        } this widget?`}
        cancelButtonText="Cancel"
        cancelButtonAction={(e) => {
          e.stopPropagation();
          setOpenedConfirmationModal(false);
          setValue(!value);
        }}
        confirmButtonText={!value ? "Unpublish" : "Publish"}
        confirmButtonAction={(e) => {
          e.stopPropagation();
          handleChange(id);
        }}
        isOpen={openedConfirmationModal}
        icon="delete"
      />
    </>
  );
};

export const RecipeWidgetManager = ({ locals, goBack }) => {
  const activeWidget = locals.activeWidget;
  const recipes = locals.recipes;
  const activeUser = locals.activeUser;
  const organizationOwner = locals.organizationOwner;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const { origin } = locals;
  const [formState, setFormState] = useState({}); //state to control the widget's form
  const [recipeState, setRecipeState] = useState([]); //state to control the recipes of the widget
  const [addNew, setAddNew] = useState("addNewButton"); //state to control if the "add new recipe" section is open or not
  const [statusState, setStatusState] = useState("save"); //state to control if the recipes are in "edit order" mode
  const [refreshList, setRefreshList] = useState(false);
  const [editWidgetInfoModalOpened, setEditWidgetInfoModalOpened] =
    useState(false);
  //state to control the accordion state
  const [accordionState, setAccordionState] = useState({
    isOpen: false,
    _id: "",
  });
  const [changedOrder, setChangedOrder] = useState(false);

  /**
   * Order the recipes
   */
  useEffect(() => {
    if (document.querySelector(".principal-grabber-div")) {
      scriptLoader(
        "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js",
        () => {
          const dragImage = document.createElement("img");
          dragImage.src =
            "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
          const sortable = new Sortable(
            document.querySelector(".principal-grabber-div"),
            {
              animation: 350,
              handle: ".drag-wrapper",
              setData(dataTransfer) {
                dataTransfer.setDragImage(dragImage, 0, 0);
              },
              onEnd: (e) => {
                if (e.oldIndex === e.newIndex) return;

                const items = e.from.querySelectorAll(":scope > div");
                e.from.insertBefore(
                  e.item,
                  items[e.oldIndex + (e.oldIndex > e.newIndex)]
                );

                const ordered = Array.from(items).map((element) => {
                  const dietaryRestrictionsInput = element.querySelector(
                    ".dietary-restrictions-section-div"
                  );
                  const stepsInput =
                    element.querySelector(".steps-section-div");
                  const ingredientsInput = element.querySelector(
                    ".ingredients-section-div"
                  );
                  const imageInput =
                    element.querySelector(".image-section-div");
                  const idInput = element.querySelector(".id-section-div");
                  const descriptionInput = element.querySelector(
                    ".description-section-div"
                  );
                  const difficultyInput = element.querySelector(
                    ".difficulty-section-div"
                  );
                  const statusInput = element.querySelector(
                    ".status-section-div"
                  );
                  const foodTypeInput = element.querySelector(
                    ".foodType-section-div"
                  );
                  const macrosBaseInput = element.querySelector(
                    ".macrosBase-section-div"
                  );
                  const prepTimeInput = element.querySelector(
                    ".prepTime-section-div"
                  );
                  const servingsInput = element.querySelector(
                    ".servings-section-div"
                  );
                  const proteinInput = element.querySelector(
                    ".protein-section-div"
                  );
                  const fiberInput =
                    element.querySelector(".fiber-section-div");
                  const fatInput = element.querySelector(".fat-section-div");
                  const carbInput = element.querySelector(".carb-section-div");
                  const nameInput = element.querySelector(".name-section-div");

                  return {
                    image:
                      (imageInput?.value && JSON.parse(imageInput.value)) || "",
                    widget: activeWidget._id,
                    _id: (idInput && idInput.value) || "",
                    status: (statusInput && statusInput.value) || "",
                    difficulty:
                      (difficultyInput && difficultyInput.value) || "",
                    description:
                      (descriptionInput && descriptionInput.value) || "",
                    foodType: (foodTypeInput && foodTypeInput.value) || "",
                    prepTime: (prepTimeInput && prepTimeInput.value) || "",
                    servings:
                      (servingsInput && parseInt(servingsInput.value)) || 0,
                    macrosBase:
                      (macrosBaseInput && macrosBaseInput.value) || "",
                    name: (nameInput && nameInput.textContent) || "",
                    steps:
                      (stepsInput && stepsInput.textContent.split("^")) || "",
                    dietaryRestrictions:
                      (dietaryRestrictionsInput &&
                        dietaryRestrictionsInput.textContent.split("^")) ||
                      "",
                    nutrients: {
                      carbs:
                        (carbInput &&
                          parseInt(carbInput.textContent.slice(0, -1))) ||
                        0,
                      fats:
                        (fatInput &&
                          parseInt(fatInput.textContent.slice(0, -1))) ||
                        0,
                      fibers:
                        (fiberInput &&
                          parseInt(fiberInput.textContent.slice(0, -1))) ||
                        0,
                      proteins:
                        (proteinInput &&
                          parseInt(proteinInput.textContent.slice(0, -1))) ||
                        0,
                    },
                    ingredients:
                      (ingredientsInput?.textContent &&
                        JSON.parse(ingredientsInput.textContent)) ||
                      "",
                  };
                });
                setRecipeState(ordered);
                setChangedOrder(true);
                return false;
              },
            }
          );
        }
      );
    }
  }, []);

  /**
   * Assign the values to the states
   */
  const [compareBase, setCompareBase, setCurrentCompareState, hasChanged] =
    useCompareState();
  useEffect(() => {
    if (!!activeWidget) {
      setFormState({
        id: activeWidget._id,
        name: activeWidget.name,
        description: activeWidget.description,
        icon: activeWidget.icon,
        order: activeWidget.order,
        status: activeWidget.status,
        type: activeWidget.type,
        pushPermission:
          activeWidget.pushPermission === undefined
            ? true
            : activeWidget.pushPermission,

        pullPermission:
          activeWidget.pullPermission === undefined
            ? true
            : activeWidget.pullPermission,
      });
      const comparingBase = {
        name: activeWidget.name,
        description: activeWidget.description,
        icon: activeWidget.icon,
        pushPermission:
          activeWidget.pushPermission === undefined
            ? true
            : activeWidget.pushPermission,
        pullPermission:
          activeWidget.pullPermission === undefined
            ? true
            : activeWidget.pullPermission,
      };
      setCompareBase(comparingBase);
      setCurrentCompareState(comparingBase);
    }
    if (!!recipes) {
      setRecipeState(recipes);
    }
  }, [activeWidget, recipes]);

  /**
   * Close the "add new recipe" section"
   */
  useEffect(() => {
    if (locals.query.submited) {
      setAddNew("addNewButton");
    }
  }, [locals.query]);

  const {
    description = "",
    name = "",
    icon = "",
    id = 0,
    order = 0,
    status = "",
    type = "",
    pushPermission = true,
    pullPermission = true,
  } = formState;

  /**
   * Reorder the recipes
   * @param {*} e
   */
  const handleSaveReorder = (e) => {
    e.preventDefault();
    const orderedRecipes = recipeState.map((element) => element._id);
    if (orderedRecipes.length > 0) {
      setStatusState("save");
      submit("/actions/recipes/reorder", {
        method: "POST",
        body: { orderedRecipes },
      });
    }
  };
  const cancelReorder = () => {
    setRecipeState(recipes);
    setStatusState("save");
    setRefreshList(!refreshList);
  };
  /**
   * Check the validation of the widget's form
   * @returns
   */
  const validationSubmit = () => {
    if (description.length > 0 && name.length > 0 && icon.length > 0) {
      return true;
    }
    return false;
  };

  /**
   * Assign the value of the widget's form
   * @param {*} param0
   */
  const handleInputChange = ({ target }) => {
    const targetName = target?.name.replace("-mobile", "") || target?.name;
    const newState = Object.assign({}, formState, {
      [targetName]: target.value,
    });

    setFormState(newState);
    setCurrentCompareState({
      ...compareBase,
      [targetName]: target.value,
    });
  };

  /**
   * Edit the widget
   * @param {*} e
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    const body = formState;
    delete body.order;
    delete body.status;
    delete body.type;
    delete body.id;

    submit(`/actions/widgets/save/${id}`, {
      method: "POST",
      body: body,
    });
  };
  const handleGoToMain = () => {
    if (accordionState.isOpen) {
      setAccordionState({ isOpen: false, _id: "" });
    }
    if (addNew === "addNewForm") {
      setAddNew("addNewButton");
    }
  };

  /**
   * state to control if the recipes are in "change order" mode or not
   * @param {*} state
   */
  const handleChangeStatusState = (state) => {
    setStatusState(state);
  };

  /**
   * Delete a widget
   * @param {*} e
   */
  const deleteWidget = (e) => {
    if (!!activeWidget) {
      const { _id } = activeWidget;
      deleteWidgetUtil(e, _id);
    }
  };

  /**
   * Refresh the page cleaning the submited query
   */
  const handleRefresh = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { submited: "" },
    });
  };

  /**
   * Open the edit widget info modal (only for mobile)
   */
  const onOpenEditWidgetInfo = () => {
    setEditWidgetInfoModalOpened(!editWidgetInfoModalOpened);
  };

  /**
   * Control the widget acess
   * @param {*} param0
   * @returns
   */
  const WidgetTogglePush = ({ permission }) => {
    return (
      <div className="labeled-switch" sz="large">
        <span>Subscriptions (PUSH)</span>
        <input
          type="checkbox"
          id="switch-1"
          name="switch-1"
          role="switch"
          onChange={() => {
            const newState = Object.assign({}, formState, {
              pushPermission: !formState.pushPermission,
            });
            setFormState(newState);
            setCurrentCompareState({
              ...compareBase,
              pushPermission: !formState.pushPermission,
            });
          }}
          checked={permission ? true : undefined}
        />
      </div>
    );
  };

  const WidgetTogglePull = ({ permission }) => {
    return (
      <div className="labeled-switch" sz="large">
        <span>Coaching (PULL)</span>
        <input
          type="checkbox"
          id="switch-1"
          name="switch-1"
          role="switch"
          onChange={() => {
            const newState = Object.assign({}, formState, {
              pullPermission: !formState.pullPermission,
            });
            setFormState(newState);
            setCurrentCompareState({
              ...compareBase,
              pullPermission: !formState.pullPermission,
            });
          }}
          checked={permission ? true : undefined}
        />
      </div>
    );
  };

  return (
    <main className="widgets-manager list recipes">
      <WidgetManagerHeader
        name={name}
        description={description}
        goBack={goBack}
        onOpenEditWidgetInfo={onOpenEditWidgetInfo}
      />
      <EditWidgetInfoModal
        widgetName={formState.name}
        widgetDescription={formState.description}
        widgetIcon={formState.icon}
        isOpen={editWidgetInfoModalOpened}
        onClose={onOpenEditWidgetInfo}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        validationSubmit={validationSubmit}
        iconsRadios={WIDGET_ICONS["recipe"]}
        WidgetTogglePull={WidgetTogglePull}
        WidgetTogglePush={WidgetTogglePush}
        userToRequest={userToRequest}
        pullPermission={pullPermission}
        pushPermission={pushPermission}
      />
      <div>
        {!!activeWidget && (
          <aside className="mobile-hidden">
            <div className="overflow-auto max-h-[calc(100vh-16.75rem)]">
              <label> Widget name </label>
              <input
                name="name"
                className="text-input"
                placeholder={`Enter Name`}
                value={name}
                maxLength="30"
                onChange={handleInputChange}
              />
              <label> Widget description </label>
              <textarea
                maxLength="60"
                name="description"
                className="text-input"
                placeholder={`Enter description here..`}
                value={description}
                onChange={handleInputChange}
              />

              <ImageRadio
                label="Widget icon"
                name="icon"
                currentValue={icon}
                radios={WIDGET_ICONS["recipe"]}
                onChange={handleInputChange}
                isManager={true}
              />

              <label>User type access</label>
              {isPullActiveCoach(userToRequest) && (
                <WidgetTogglePull permission={pullPermission} />
              )}
              {userToRequest.pushAccountInfo && (
                <WidgetTogglePush permission={pushPermission} />
              )}
            </div>
            <footer>
              <button
                data-button-type="secondary"
                data-action="cancel"
                onClick={deleteWidget}
              >
                Delete
              </button>
              <button
                data-button-type="primary"
                onClick={handleSubmit}
                disabled={!hasChanged}
              >
                Save
              </button>
            </footer>
          </aside>
        )}
        {!!recipes && (
          <section>
            <header>
              <section className="only-show-mobile back-handler">
                <SvgIcon
                  src={"/img/new-icons/back-button.svg"}
                  onClickFn={() =>
                    submit(`/actions/refresh/?`, {
                      method: "GET",
                      body: { section: "", learn: "" },
                    })
                  }
                />
                <h3>{activeWidget?.name || "Explore"}</h3>
              </section>
              <hgroup className="mobile-hidden">
                {(addNew === "addNewForm" || accordionState.isOpen) && (
                  <SvgIcon
                    src="/img/new-icons/back-button.svg"
                    onClickFn={handleGoToMain}
                    classNames="cursor-pointer"
                  />
                )}
                <div>
                  <h4>
                    {addNew === "addNewForm"
                      ? "Add New Recipe"
                      : accordionState.isOpen
                      ? accordionState.name
                      : "Recipes"}
                  </h4>
                  {addNew === "addNewButton" && !accordionState.isOpen && (
                    <p className="p6">Create and manage your recipes</p>
                  )}
                </div>
              </hgroup>

              {statusState === "save" &&
                !accordionState.isOpen &&
                addNew === "addNewButton" && (
                  <button
                    data-button-type="secondary"
                    onClick={() => handleChangeStatusState("change-order")}
                  >
                    Change order
                  </button>
                )}
              {statusState === "change-order" && (
                <hgroup className="actions-wrapper">
                  <button
                    data-button-type="primary"
                    onClick={handleSaveReorder}
                    disabled={!changedOrder}
                  >
                    Save
                  </button>
                  <button
                    data-button-type="secondary"
                    data-action="cancel"
                    onClick={cancelReorder}
                  >
                    Cancel
                  </button>
                </hgroup>
              )}
            </header>
            {addNew === "addNewButton" && !accordionState.isOpen && (
              <div className="principal-grabber-div">
                {orderWidgets(recipeState).map(
                  ({
                    _id,
                    image,
                    name,
                    status,
                    nutrients,
                    prepTime,
                    difficulty,
                    foodType,
                    dietaryRestrictions = [""],
                    ingredients,
                    steps = [""],
                    servings,
                    description,
                    macrosBase,
                  }) => {
                    const { proteins, fats, carbs, fibers } = nutrients;
                    const proteinsKcal = Math.round(proteins * 4);
                    const carbsKcal = Math.round(carbs * 4);
                    const fatsKcal = Math.round(fats * 9);
                    const calories = Math.round(
                      proteinsKcal + carbsKcal + fatsKcal
                    );
                    return (
                      <div className="article-wrapper">
                        <article
                          key={`${_id}-${refreshList}`}
                          id={_id}
                          className={
                            statusState === "change-order"
                              ? "div-recipe columns column item-grabber-container"
                              : "div-recipe columns item-grabber-container"
                          }
                          onClick={() => {
                            setAccordionState(
                              Object.assign({}, accordionState, {
                                isOpen: !accordionState.isOpen,
                                _id,
                                image,
                                name,
                                status,
                                nutrients,
                                prepTime,
                                difficulty,
                                foodType,
                                dietaryRestrictions,
                                ingredients,
                                steps,
                                servings,
                                description,
                                macrosBase,
                              })
                            );
                          }}
                        >
                          <div className="column width-widget-information">
                            <div>
                              <input
                                className="foodType-section-div"
                                name="foodType"
                                style={{ display: "none" }}
                                readOnly
                                value={foodType}
                              />
                              <input
                                className="macrosBase-section-div"
                                name="macrosBase"
                                style={{ display: "none" }}
                                readOnly
                                value={macrosBase}
                              />
                              <input
                                className="prepTime-section-div"
                                name="prepTime"
                                style={{ display: "none" }}
                                readOnly
                                value={prepTime}
                              />
                              <input
                                className="servings-section-div"
                                name="servings"
                                style={{ display: "none" }}
                                readOnly
                                value={servings}
                              />
                              <input
                                className="difficulty-section-div"
                                name="difficulty"
                                style={{ display: "none" }}
                                readOnly
                                value={difficulty}
                              />
                              <input
                                className="description-section-div"
                                name="desc"
                                style={{ display: "none" }}
                                readOnly
                                value={description}
                              />
                              <input
                                className="status-section-div"
                                name="status"
                                style={{ display: "none" }}
                                readOnly
                                value={status}
                              />
                              <input
                                className="id-section-div"
                                name="id"
                                style={{ display: "none" }}
                                readOnly
                                value={_id}
                              />
                              <span
                                style={{ display: "none" }}
                                className="dietary-restrictions-section-div"
                              >
                                {dietaryRestrictions === null
                                  ? [""]
                                  : dietaryRestrictions.join("^")}
                              </span>
                              <span
                                style={{ display: "none" }}
                                className="steps-section-div"
                              >
                                {steps.join("^")}
                              </span>
                              <input
                                className="image-section-div"
                                name="image"
                                style={{ display: "none" }}
                                readOnly
                                value={JSON.stringify(image)}
                              />
                              <span
                                style={{ display: "none" }}
                                className="ingredients-section-div"
                              >
                                {JSON.stringify(ingredients)}
                              </span>
                              {image && (
                                <img
                                  src={`${S3.PATH}${image.s3Path}`}
                                  loading="lazy"
                                />
                              )}
                            </div>
                            <div>
                              <p className="s2 name-section-div">{name}</p>

                              <div>
                                <div className="font-recipe-details protein">
                                  <p className="p4 protein-section-div">
                                    {" "}
                                    {proteins || ""}g Protein
                                  </p>
                                </div>

                                <div className="font-recipe-details carbs">
                                  <p className="p4 carb-section-div">
                                    {" "}
                                    {carbs || ""}g Carbs
                                  </p>
                                </div>

                                <div className="font-recipe-details fat">
                                  <p className="p4 fat-section-div">
                                    {fats || ""}g Fat
                                  </p>
                                  <div className="box-recipe"></div>
                                </div>

                                <div className="font-recipe-details kcal">
                                  <p className="p4 fiber-section-div">
                                    {fibers || ""}g Fiber
                                  </p>
                                </div>

                                <div className="font-recipe-details">
                                  <p className="p4 calories">
                                    {calories || ""} kCal
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              statusState === "change-order"
                                ? "mobile-hidden"
                                : ""
                            } publish-switch-wrapper`}
                          >
                            <WidgetToggle status={status} id={_id} />
                          </div>
                        </article>
                        {statusState === "change-order" && (
                          <div className="drag-wrapper">
                            <SvgIcon
                              src="/img/new-icons/menu.svg"
                              className="drag-handle mobile-hidden"
                              mobileSrc={"/img/new-icons/drag.svg"}
                            />
                          </div>
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {accordionState.isOpen && (
              <EditRecipe
                idProp={accordionState._id}
                widget={id}
                imageProp={accordionState.image}
                nameProp={accordionState.name}
                statusProp={accordionState.status}
                nutrientsProp={accordionState.nutrients}
                prepTimeProp={accordionState.prepTime}
                difficultyProp={accordionState.difficulty}
                foodTypeProp={accordionState.foodType}
                dietaryRestrictionsProp={accordionState.dietaryRestrictions}
                ingredientsProp={accordionState.ingredients}
                stepsProp={accordionState.steps}
                servingsProp={accordionState.servings}
                descriptionProp={accordionState.description}
                macrosBaseProp={accordionState.macrosBase}
                handleRenderStateChange={setAccordionState}
                hasImage={true}
                locals={locals}
              />
            )}
            {addNew === "addNewButton" && !accordionState.isOpen && (
              <div
                className="dashed-box"
                onClick={() => {
                  setAccordionState({ isOpen: false, _id: "" });
                  setAddNew("addNewForm");
                  // handleRefresh();
                }}
              >
                <SvgIcon
                  src="/img/new-icons/add-square-outline.svg"
                  alt="back"
                />
                <p className="p4">Add New Recipe</p>
              </div>
            )}
            {addNew === "addNewForm" && <EditRecipe locals={locals} />}
            {addNew === "addNewButton" ||
              (addNew === "editForm" && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    className={
                      validationSubmit()
                        ? "save-macro-btn"
                        : "save-macro-disabled-btn save-macro-btn"
                    }
                    onClick={handleSubmit}
                    disabled={!validationSubmit()}
                  >
                    Save
                  </button>
                </div>
              ))}
          </section>
        )}
      </div>
    </main>
  );
};
